const SearchIcon = ({ className = '' }: { className?: string }) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={`stroke-[#442E83] ${className}`}
  >
    <g clipPath='url(#clip0_15446_1976)'>
      <path
        d='M14.6668 14.6667L10.4375 10.4373'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M6.66683 12C9.61235 12 12.0002 9.61217 12.0002 6.66665C12.0002 3.72113 9.61235 1.33331 6.66683 1.33331C3.72131 1.33331 1.3335 3.72113 1.3335 6.66665C1.3335 9.61217 3.72131 12 6.66683 12Z'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </g>
    <defs>
      <clipPath id='clip0_15446_1976'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default SearchIcon
